import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  optionTitle: {
    fontWeight: 'bolder',
  },
}))

export default styles
